export default "__VITE_ASSET__PI5HsizJ__"